import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

@Component({
  selector: "abbey-tool",
  templateUrl: "abbey-tool.html",
})
export class AbbeyToolComponent implements OnInit {
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();
  @Input() readonly: boolean = false;

  formGroup: FormGroup;

  vocalizationConfig = {};
  facialExpressionConfig = {};
  changeBodyLanguageConfig = {};
  behavioralChangeConfig = {};
  physiologicalChangeConfig = {};
  physicalChangeConfig = {};

  constructor(
    public formBuilder: FormBuilder,
    public stateData: StateManagementService
  ) {
    this.formGroup = this.formBuilder.group({});
    this.formGroup.addControl(
      "abbeyVocalization",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "abbeyFacialExpression",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "abbeyBodyLanguage",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "abbeyBehavioralChange",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "abbeyPhysiologicalChange",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl(
      "abbeyPhysicalChange",
      this.formBuilder.control(undefined)
    );

    this.formGroup.valueChanges.subscribe((data) => {
      let severity = 0;
      let cuurentValue: boolean = false;
      let allNull = true;
      for (let field of Object.keys(data)) {
        severity += data[field] * 1;
        if (data[field] !== null) {
          if (data[field] > 0) cuurentValue = true;
          allNull = false;
        }
      }
      if (cuurentValue == true) this.stateData.setMyData(1);
      else this.stateData.setMyData(0);
      this.onValueUpdate.emit({
        values: data,
        severity: allNull ? null : severity,
      });
    });
  }

  ngOnInit(): void {
    let options = ["0", "1", "2", "3"];
    let descriptions = {
      "0": "abbeyAbsent",
      "1": "abbeyMild",
      "2": "abbeyModerate",
      "3": "abbeySevere",
    };

    this.vocalizationConfig["id"] = "abbeyVocalization";
    this.vocalizationConfig["componentId"] = "abbeyVocalization";
    this.vocalizationConfig["readonly"] = this.readonly;
    this.vocalizationConfig["options"] = options;
    this.vocalizationConfig["descriptions"] = descriptions;

    this.facialExpressionConfig["id"] = "abbeyFacialExpression";
    this.facialExpressionConfig["componentId"] = "abbeyFacialExpression";
    this.facialExpressionConfig["readonly"] = this.readonly;
    this.facialExpressionConfig["options"] = options;
    this.facialExpressionConfig["descriptions"] = descriptions;

    this.changeBodyLanguageConfig["id"] = "abbeyBodyLanguage";
    this.changeBodyLanguageConfig["componentId"] = "abbeyBodyLanguage";
    this.changeBodyLanguageConfig["readonly"] = this.readonly;
    this.changeBodyLanguageConfig["options"] = options;
    this.changeBodyLanguageConfig["descriptions"] = descriptions;

    this.behavioralChangeConfig["id"] = "abbeyBehavioralChange";
    this.behavioralChangeConfig["componentId"] = "abbeyBehavioralChange";
    this.behavioralChangeConfig["readonly"] = this.readonly;
    this.behavioralChangeConfig["options"] = options;
    this.behavioralChangeConfig["descriptions"] = descriptions;

    this.physiologicalChangeConfig["id"] = "abbeyPhysiologicalChange";
    this.physiologicalChangeConfig["componentId"] = "abbeyPhysiologicalChange";
    this.physiologicalChangeConfig["readonly"] = this.readonly;
    this.physiologicalChangeConfig["options"] = options;
    this.physiologicalChangeConfig["descriptions"] = descriptions;

    this.physicalChangeConfig["id"] = "abbeyPhysicalChange";
    this.physicalChangeConfig["componentId"] = "abbeyPhysicalChange";
    this.physicalChangeConfig["readonly"] = this.readonly;
    this.physicalChangeConfig["options"] = options;
    this.physicalChangeConfig["descriptions"] = descriptions;
  }

  @Input() set existingData(data: object) {
    if (data && data["tool"] === "abbey" && data["values"]) {
      this.formGroup.setValue(data["values"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/abbey-tool/abbey-tool.ts